module.exports = __webpack_public_path__ + "static/img/left-top-row-4.f3851ed3.webp";